import type { RegistryEntry } from "../../shared.ts";

export const bazaarlinkProvider: RegistryEntry = {
  id: "bazaarlink",
  alias: "bzl",
  format: "openai",
  executor: "default",
  baseUrl: "https://bazaarlink.ai/api/v1/chat/completions",
  modelsUrl: "https://bazaarlink.ai/api/v1/models",
  authType: "apikey",
  authHeader: "bearer",
  models: [
    { id: "auto:free", name: "Auto Free (Zero Cost)" },
    { id: "claude-opus-4.7", name: "Claude Opus 4.7" },
    { id: "claude-sonnet-4.6", name: "Claude Sonnet 4.6" },
    { id: "claude-haiku-4.5", name: "Claude Haiku 4.5" },
    { id: "gpt-5.5", name: "GPT-5.5" },
    { id: "gpt-5.4", name: "GPT-5.4" },
    { id: "gpt-5.4-mini", name: "GPT-5.4 Mini" },
    { id: "gpt-5.4-nano", name: "GPT-5.4 Nano" },
    { id: "grok-4.3", name: "Grok 4.3" },
    { id: "grok-4.20", name: "Grok 4.20" },
    { id: "gemini-3.1-pro-preview", name: "Gemini 3.1 Pro" },
    { id: "gemini-3-flash-preview", name: "Gemini 3 Flash" },
    { id: "gemini-3.1-flash-lite-preview", name: "Gemini 3.1 Flash Lite" },
    { id: "gemma-4-31b-it", name: "Gemma 4 31B" },
    { id: "gemma-4-26b-a4b-it", name: "Gemma 4 26B A4B" },
    { id: "deepseek-v3.2", name: "DeepSeek V3.2" },
    { id: "kimi-k2.6", name: "Kimi K2.6" },
    { id: "kimi-k2.5", name: "Kimi K2.5" },
    { id: "glm-5.1", name: "GLM 5.1" },
    { id: "glm-5", name: "GLM 5" },
    { id: "mimo-v2.5-pro", name: "MiMo-V2.5-Pro" },
    { id: "mimo-v2.5", name: "MiMo-V2.5" },
    // #3110: MiniMax M3 via OpenCode Zen
    { id: "minimax-m3", name: "MiniMax M3", contextLength: 1048576, supportsVision: true },
    { id: "minimax-m2.7", name: "MiniMax M2.7" },
    { id: "minimax-m2.5", name: "MiniMax M2.5" },
    { id: "llama-4-maverick", name: "Llama 4 Maverick" },
    { id: "llama-4-scout", name: "Llama 4 Scout" },
    { id: "llama-3.3-70b-instruct", name: "Llama 3.3 70B" },
    { id: "qwen3.6-plus", name: "Qwen 3.6 Plus" },
    { id: "mistral-large-2512", name: "Mistral Large 3" },
    { id: "mistral-medium-3.1", name: "Mistral Medium 3.1" },
    { id: "mistral-small-2603", name: "Mistral Small 4" },
    { id: "nemotron-3-super-120b-a12b", name: "Nemotron 3 Super" },
  ],
};
